export default "__VITE_ASSET__CFhb0VXT__"